import { useState, useEffect } from 'react';

const SESSION_STORAGE_KEY = 'hotjar_successfully_installed';

function getSessionStorageKey(siteId: number): string {
  return `${SESSION_STORAGE_KEY}_${siteId}`;
}

export function isPostInstallCardEnabled(siteId: number): boolean {
  return !!window.sessionStorage.getItem(getSessionStorageKey(siteId));
}

export function enablePostInstallCard(siteId: number): void {
  window.sessionStorage.setItem(getSessionStorageKey(siteId), 'true');
}

export function disablePostInstallCard(siteId: number): void {
  window.sessionStorage.removeItem(getSessionStorageKey(siteId));
}

export function usePostInstallView(siteId: number | undefined): boolean {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (siteId && isPostInstallCardEnabled(siteId)) {
      setIsActive(true);
    }
  }, [siteId]);

  return isActive;
}
